/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ModalBody, ModalFooter, ModalHeader, ModalNext, Icon, useModal, Loader } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import {
    JobService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { Link } from '@jutro/router';
import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';
import gatewayMessages from "../../../gw-capability-gateway-react/gateway.messages";
import metadata from './UnderwritingWarningComponent.metadata.json5';
import styles from './UnderwritingWarningComponent.module.scss';
import messages from './UnderwritingWarningComponent.messages'
import UWUtil from '../../util/UWUtil';
import TWIAJobHelper from '../../util/TWIAJobHelper';

const UnderwritingWarningComponent = props => {
    const {
        submissionVM,
        addressData,
        updateVM,
        title,
        onResolve,
        isOpen,
        // onResolve,
        // onReject,
        setComponentValidation,
        history
    } = props;

    const [showReferToUW, setShowReferToUW] = useState(false);
    const { showAlert, showConfirm } = useModal();
    const [formData, updateFormData] = useState({});
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const uwIssues = _.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value');
    const PolicyChange = _.get(submissionVM, 'baseData.jobType.value.code')
    const associationName = _.get(submissionVM, 'lobData.homeowners_tfpa.associationName_TWIA.value.code') ||
                            _.get(submissionVM,'baseData.associationName_TWIA.value.code')

    const checkPolicyHold = useCallback(() => !_.isUndefined(uwIssues) && uwIssues.some(
        issue =>
            issue.isPolicyHoldTWIA
    ), [uwIssues])

    const onCancelReferUW = useCallback(() => {
        setShowReferToUW(false);
    }, []);

    const onReferToUW = useCallback(() => {
        setShowReferToUW(true);
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const onWithdrawTransaction = useCallback(() => {

        UWUtil.onWithdraw(submissionVM, showConfirm, showAlert, translator, history, authHeader)

    }, [authHeader, history, showAlert, showConfirm, submissionVM, translator]);

    const generateOverrides = useCallback(() => {
        if (!_.isUndefined(uwIssues)) {
            const uwIssuesAreBlocking = UWUtil.hasUWBlockingIssues(uwIssues)
            const overrides = !_.isUndefined(uwIssues) && uwIssuesAreBlocking.map((item, index) => {
                return {
                    [`uwMessages${index}`]: {
                        content: `${item.longDescription}\n`,
                    },
                };
            });

            return Object.assign({}, ...overrides);
        }

    }, [uwIssues]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        referToUWForm: {
            visible: showReferToUW
        },
        uwReferWitdrawButton: {
            visible: !showReferToUW && associationName !=='tfpa'
        },
        uwReferToButton: {
            visible: !checkPolicyHold()
        },
        policyHoldSaveExitButton: {
            visible: checkPolicyHold()
        },
        uwSection: {
            data: uwIssues,
            visible : associationName !=='tfpa'
        },
        // DE17833
        UWFormInfo:{
            content: PolicyChange === "PolicyChange" ? translator(messages.onceReferredChange) : translator(messages.onceReferred)
        },
        UWFormConfirm:{
            content: PolicyChange === "PolicyChange" ? translator(messages.referToUWPolicyChange) : translator(messages.referToUWSubmission)
        },
        rejectReviewWithDrawJob:{
            content: PolicyChange === "PolicyChange" ? 'Withdraw Policy Change' : 'Withdraw Quote'
        },
        ...generateOverrides()
    };

    const referQuoteToUnderWriter = useCallback(() => {
        UWUtil.onReferToUnderwriter(submissionVM, formData, history, setShowReferToUW, showAlert, authHeader)
    }, [authHeader, formData, history, showAlert, submissionVM]);

    const handleSaveExit = useCallback(() => {
        UWUtil.saveExit(submissionVM, showConfirm, history, authHeader)
    }, [authHeader, history, showConfirm, submissionVM])

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onCancelReferUW,
            onReferToUW,
            referQuoteToUnderWriter,
            onWithdrawTransaction,
            handleSaveExit
        }
    };

    const renderUWMessage = useCallback(() =>
    (<div className={styles.displaydiv}>
        <div className={styles.divpadding}>
            <Icon icon="gw-warning" size="large" className={styles.iconColor} />
        </div>
        <div>
            { PolicyChange === "PolicyChange" ? (<div>
            <div>
                <b><h3>{translator(messages.uwIssuePolicyChangeTitle)}</h3></b>
            </div>
            <div>
                {translator(messages.youCanStaticText)}
                <ul>
                    {checkPolicyHold() ? <li>{translator(messages.uwPolicyHold_twia)}</li> : ''}
                    <li>{translator(messages.editPolicyChange)}</li>
                    {!checkPolicyHold() ? <li>{translator(messages.referToUnderwriterChange)}</li> : ''}
                    <li>{translator(messages.withdrawPolicyChange)}</li>
                </ul>
            </div>
            </div>) : 
            ( <div>
            <div>
                <b><h3>{translator(messages.uwIssueTitle)}</h3></b>
            </div>
            <div>
                {translator(messages.youCanStaticText)}
                <ul>
                    {checkPolicyHold() ? <li>{translator(messages.uwPolicyHold_twia)}</li> : ''}
                    <li>{translator(messages.editQuote)}</li>
                    {!checkPolicyHold() ? <li>{translator(messages.referToUnderwriter)}</li> : ''}
                    <li>{translator(messages.withdrawQuote)}</li>
                </ul>
            </div>
            </div>
            )}
            <div>
                {translator(messages.uwIssues)}
            </div>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={formData}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                // onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                // componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </div>
    </div>

    ), [checkPolicyHold, formData, overrideProps, resolvers, translator, writeValue]);


    // DE17975
    const redirectToSummary= useCallback(()=>{
        const quoteId = submissionVM?.quoteID?.value || submissionVM?.jobID?.value
        const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
        const redirectPathBasedOnTransaction = isPolicyChange ? 'change' : 'quotes'
        submissionVM.noCancelWarning = true;
        history.push(`${process.env.PUBLIC_PATH}/${redirectPathBasedOnTransaction}/${quoteId}/summary`)
    },[history, submissionVM])

    const renderTFPAUWMessage = useCallback(() =>
    (<div className={styles.displaydiv}>
        <div className={styles.divpadding}>
                <Icon icon="gw-warning" size="large" className={styles.iconColor} />
            </div>
        <div>
            <div>
                <div>
                    <h5>{translator(messages.uwIssuePolicyChangeTFPA)}<Link onClick={()=>redirectToSummary()}>Click here</Link> {translator(messages.uwIssuePolicyChangeTFPAContinued)}</h5>
                </div>
            </div>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={formData}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                // onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                // componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </div>
    </div>

    ), [formData, overrideProps, redirectToSummary, resolvers, translator, writeValue]);

    return (
        <div >
            <p className={styles.consentScroll}>
                {associationName === 'tfpa' ? renderTFPAUWMessage():
            renderUWMessage()}</p>
        </div>
    );
};

UnderwritingWarningComponent.propTypes = wizardProps;
UnderwritingWarningComponent.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(UnderwritingWarningComponent));
